import Col from 'react-bootstrap/lib/Col'
import PropTypes from 'prop-types'
import Row from 'react-bootstrap/lib/Row'
import React from 'react'

import Input from '../../../../components/input'

const ensureNumber = (maxDigits, success) => {
  return (e) =>
    e.target.value.length <= maxDigits &&
    /^\d*$/.test(e.target.value) &&
    success(e)
}

const Personalization = ({
  errors,
  handleChange,
  selectedDesignFlags,
  touched,
  values
}) => (
  <Row>
    {selectedDesignFlags.nb && (
      <Col xs={!selectedDesignFlags.yr ? 12 : 6}>
        <Input
          label="Number"
          name="playerNumber"
          onChange={ensureNumber(2, handleChange)}
          size="block"
          type="tel"
          valid={touched.playerNumber ? !errors.playerNumber : undefined}
          value={values.playerNumber}
        />
        {touched.playerNumber && errors.playerNumber && (
          <div className="error-message">{errors.playerNumber}</div>
        )}
      </Col>
    )}
    {selectedDesignFlags.yr && (
      <Col xs={!selectedDesignFlags.nb ? 12 : 6}>
        <Input
          label="Year"
          name="classYear"
          onChange={ensureNumber(4, handleChange)}
          size="block"
          type="tel"
          valid={touched.classYear ? !errors.classYear : undefined}
          value={values.classYear}
        />
        {touched.classYear && errors.classYear && (
          <div className="error-message">{errors.classYear}</div>
        )}
      </Col>
    )}
    {selectedDesignFlags.nm && (
      <Col xs={12}>
        <Input
          label="Enter Name"
          name="playerName"
          onChange={handleChange}
          size="block"
          type="text"
          valid={touched.playerName ? !errors.playerName : undefined}
          value={values.playerName}
          maxLength="16"
        />
        {touched.playerName && errors.playerName && (
          <div className="error-message">{errors.playerName}</div>
        )}
      </Col>
    )}
  </Row>
)

Personalization.propTypes = {
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  selectedDesignFlags: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
}

export default Personalization
